// extracted by mini-css-extract-plugin
export default {"collection-item":"CollectionItem_collection-item__wvB0R","empty":"CollectionItem_empty__6YTB1","item-image":"CollectionItem_item-image__AQ7MI"};